import axios from 'axios';
import { API_URL } from './ApiConfig';

// Cliente API sin autenticación para endpoints públicos
const publicApiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interfaces
interface CheckProjectExistsRequest {
  client_email: string;
  invitation_code: number;
  owner_id: string;
}

interface CheckProjectExistsResponse {
  exists: boolean;
}

interface RegisterClientRequest {
  first_name: string;
  last_name: string;
  username: string;
  password: string;
  email: string;
  invitation_code: number;
  owner_id: string;
}

interface RegisterClientResponse {
  message: string;
  userId: string;
}

// Verificar si existe el proyecto con las credenciales de invitación
export const checkProjectExists = async (
  email: string,
  invitationCode: number,
  ownerId: string
): Promise<CheckProjectExistsResponse> => {
  const response = await publicApiClient.post<CheckProjectExistsResponse>(
    '/quiz/project/check-exists',
    {
      client_email: email,
      invitation_code: invitationCode,
      owner_id: ownerId,
    } as CheckProjectExistsRequest
  );
  return response.data;
};

// Registrar usuario invitado
export const registerInvitedUser = async (
  firstName: string,
  lastName: string,
  email: string,
  password: string,
  invitationCode: number,
  ownerId: string
): Promise<RegisterClientResponse> => {
  const response = await publicApiClient.post<RegisterClientResponse>(
    '/auth/register-client',
    {
      first_name: firstName,
      last_name: lastName,
      username: email, // Usar email como username
      password,
      email,
      invitation_code: invitationCode,
      owner_id: ownerId,
    } as RegisterClientRequest
  );
  return response.data;
};
